import React from 'react';
import round from 'lodash/round';
import { Link } from 'react-router-dom';

const legendNames = [
  {
    in: 'sleepHours',
    out: 'Total'
  },
  {
    in: 'sleepHoursDeep',
    out: 'Hrs Sueño Profundo'
  },
  {
    in: 'sleepHoursLight',
    out: 'Hrs Sueño Ligero'
  },
  {
    in: 'sleepHoursAwake',
    out: 'Hrs Sueño Despierto'
  },
  {
    in: 'SleepHoursAVG',
    out: 'Total'
  },
  {
    in: 'SleepHoursDeepAVG',
    out: 'Hrs Sueño Profundo'
  },
  {
    in: 'SleepHoursLightAVG',
    out: 'Hrs Sueño Ligero'
  },
  {
    in: 'SleepHoursAwakeAVG',
    out: 'Hrs Sueño Despierto'
  }
]

const legendNameSwapper = (name) => {
  const found = legendNames.find(item => item.in === name);
  if (found === undefined) {
    console.error('Legend name not found?!');
    return;
  }
  return found.out;
}

const refLines = [
  {
    source: 'stress',
    value: 26
  },
  {
    source: 'sleep',
    value: 7
  },
  {
    source: 'cardiovascular',
    value: 30
  },
  {
    source: 'steps',
    value: 60
  },
  {
    source: 'kms',
    value: 1
  },
  {
    source: 'calories',
    value: 1000
  },
];

const getRefValue = (name) => {
  const found = refLines.find(item => item.source === name);
  if (found === undefined) {
    console.error('Ref line not found?!');
    return;
  }
  return found.value;
}

const getCategoryCounts = (values, ranges) => {
  const ret = [];

  for (const r of ranges) {
    ret.push({ category: r.message, value: 0 });
  }

  for (const value of values) {
    for (let i = 0; i < ranges.length; i++) {
      if (value >= ranges[i].low && value <= ranges[i].high) {
        ret[i].value++;
        break;
      }
    }
  }

  return ret;
}

const getTableValBadge = (value, ranges) => {
  let status, message;
  for (const r of ranges) {
    if (value >= r.low && value <= r.high) {
      status = r.status;
      message = r.message;
      break;
    }
  }

  let badgeClassName = 'badge ';
  switch (status) {
    case 'good': badgeClassName += 'badge-success'; break;
    case 'ok': badgeClassName += 'badge-info'; break;
    case 'warning': badgeClassName += 'badge-warning'; break;
    case 'bad': badgeClassName += 'badge-danger'; break;
    default: break;
  }

  return (
    <div className="d-flex align-items-center">
      <span className="mr-1">{round(value, 2)}</span>
      <span className={badgeClassName}>
        {message}
      </span>
    </div>
  )
}

const getTableID = (id, name) => {
  return(
    <Link to={`/levels/${id}`}>
      {name}
    </Link>
  )
}

const makeClickable = (name) => {
  return(
    <Link to={`#`}>
      {name}
    </Link>
  )
}

export { legendNameSwapper, getRefValue, getCategoryCounts, getTableValBadge , getTableID, makeClickable};
